<template>
  <v-col>
    <h3>
      <template v-if="isEditing">
        Editing Repair
      </template>
      <template v-else>
        Add New Repair
      </template>
    </h3>
    <v-row>
      <v-col
        cols="12"
        md="8"
        sm="4"
      >
        <v-card outlined>
          <v-card-text>
            <div>Customer Information</div>
            <v-row>
              <v-col
                cols="12"
                md="12"
                sm="12"
              >
                <v-text-field
                  v-model="form.name"
                  hide-details="auto"
                  label="Full Name"
                  outlined
                  dense
                  :error-messages="errors.getMessage('name')"
                />
              </v-col>
              <template v-if="hide">
                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <v-text-field
                    v-model="form.email"
                    hide-details="auto"
                    label="Email"
                    outlined
                    dense
                    :error-messages="errors.getMessage('email')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <v-text-field
                    v-model="form.phone"
                    hide-details="auto"
                    label="Phone"
                    outlined
                    dense
                    :error-messages="errors.getMessage('phone')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="form.address"
                    hide-details="auto"
                    label="Address"
                    outlined
                    dense
                    :error-messages="errors.getMessage('address')"
                  />
                </v-col>
              </template>
              <template v-else>
                <div
                  class="btn text-center"
                  @click="hide = true"
                >
                  <v-btn icon>
                    <v-icon>mdi-unfold-less-horizontal</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card
          class="mt-5"
          outlined
        >
          <v-card-text>
            <div>Issue Description</div>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="form.issue"
                  label="Issue"
                  outlined
                  rows="2"
                  dense
                  :error-messages="errors.getMessage('issue')"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="12"
              >
                <v-text-field
                  v-model="form.deviceName"
                  hide-details="auto"
                  label="Device Name"
                  outlined
                  dense
                  :error-messages="errors.getMessage('deviceName')"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="12"
              >
                <v-text-field
                  v-model="form.imei"
                  hide-details="auto"
                  label="IMEI"
                  outlined
                  dense
                  :error-messages="errors.getMessage('imei')"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="12"
              >
                <v-text-field
                  v-model="form.sNumber"
                  hide-details="auto"
                  label="Serial Number"
                  outlined
                  dense
                  :error-messages="errors.getMessage('sNumber')"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="12"
      >
        <v-card outlined>
          <v-card-text>
            <v-col>
              <v-text-field
                v-model="form.charges"
                hide-details="auto"
                label="Charges"
                outlined
                dense
                type="number"
                :error-messages="errors.getMessage('charges')"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.taxRate"
                hide-details="auto"
                label="Tax Rate %"
                outlined
                dense
                type="number"
                :error-messages="errors.getMessage('taxRate')"
              />
            </v-col>

            <v-col>
              <v-text-field
                v-model="form.prePaid"
                hide-details="auto"
                label="Paid Amount"
                outlined
                dense
                type="number"
                :error-messages="errors.getMessage('prePaid')"
              />
            </v-col>

            <table class="table">
              <tbody>
                <tr>
                  <th>Charges</th>
                  <td>{{ form.charges | currency }}</td>
                </tr>
                <tr>
                  <th>After Tax ({{ form.taxRate }} %)</th>
                  <td>{{ afterTax | currency }}</td>
                </tr>
                <tr>
                  <th>PrePaid Amount</th>
                  <td>{{ form.prePaid | currency }}</td>
                </tr>
                <tr>
                  <th>Due Amount</th>
                  <td>{{ due | currency }}</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
        <div class="text-center">
          <v-btn
            color="green"
            class="ma-2 white--text"
            @click="submitRrepair"
          >
            Save
            <v-icon
              right
              dark
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      hide: false,
      isEditing: false,
      form: {
        charges: 0,
        taxRate: 0,
        prePaid: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
    afterTax() {
      const info = this.$data.form;
      info.taxAmount = info.charges * (info.taxRate / 100);
      return Number(info.charges) + Number(info.taxAmount);
    },
    due() {
      return this.afterTax - this.$data.form.prePaid;
    },
  },
  mounted() {
    if (this.$route.params.id) {
      window.axios.get("/repair/" + this.$route.params.id).then((response) => {
        this.$data.form = response.data.repair;
        this.isEditing = true;
      });
    }
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    submitRrepair() {
      this.$data.form.totalAmount = this.afterTax;
      this.$data.form.due = this.due;
      if (this.isEditing) {
        this.updateRepair();
      } else {
        this.addRepair();
      }
    },
    updateRepair() {
      window.axios
        .patch("/repair/" + this.$route.params.id, this.$data.form)
        .then((response) => {
          this.feedback(response.data.message);
          this.$router.push({ name: "RepiarList" });
        });
    },
    addRepair() {
      window.axios.post("/repair", this.$data.form).then((response) => {
        this.feedback(response.data.message);
        this.$router.push({
          name: "RepiarPrint",
          params: { id: response.data.repair },
        });
      });
    },
  },
};
</script>
